import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
const mm = gsap.matchMedia();

// Utility functions
const createPillScrollTrigger = (
  item: HTMLElement,
  index: number,
  textBlocks: HTMLElement[],
  pillDuration: number,
  offset: number
) => ({
  trigger: item,
  start: `top-=${offset}px center`,
  end: 'bottom center',
  scrub: false,
  markers: false,
  onEnter: () => highlightPill(item, index, textBlocks, pillDuration),
  onLeave: () => resetPill(item, index, textBlocks, pillDuration),
  onEnterBack: () => highlightPill(item, index, textBlocks, pillDuration),
  onLeaveBack: () => resetPill(item, index, textBlocks, pillDuration),
});

const highlightPill = (
  item: HTMLElement,
  index: number,
  textBlocks: HTMLElement[],
  pillDuration: number
) => {
  gsap.to(item, {
    backgroundColor: 'var(--base-color-neutral--950)',
    color: 'var(--base-color-neutral--50)',
    duration: pillDuration,
  });

  if (index !== 0) {
    gsap.to(textBlocks[0], { backgroundColor: '', color: '', duration: pillDuration });
  }

  if (index !== textBlocks.length - 1) {
    gsap.to(textBlocks[textBlocks.length - 1], {
      backgroundColor: '',
      color: '',
      duration: pillDuration,
    });
  }
};

const resetPill = (
  item: HTMLElement,
  index: number,
  textBlocks: HTMLElement[],
  pillDuration: number
) => {
  if (index !== textBlocks.length - 1 && index !== 0) {
    gsap.to(item, { backgroundColor: '', color: '', duration: pillDuration });
  }
};

const setupPillAnimations = () => {
  const pillDuration = 0;
  const textBlocks = gsap.utils.toArray('[gsap="pill"]') as HTMLElement[];

  mm.add('(min-width: 480px)', () => {
    const remValue = parseFloat((textBlocks[0].offsetHeight / 6.9).toFixed(4));

    textBlocks.forEach((item, index) => {
      ScrollTrigger.create(
        createPillScrollTrigger(item, index, textBlocks, pillDuration, remValue)
      );
    });
  });

  mm.add('(max-width: 479px)', () => {
    const remValue = parseFloat((textBlocks[0].offsetHeight / 3.9 / 2).toFixed(4));

    textBlocks.forEach((item, index) => {
      ScrollTrigger.create(
        createPillScrollTrigger(item, index, textBlocks, pillDuration, remValue / 2)
      );
    });
  });

  gsap.set(textBlocks[0], {
    backgroundColor: 'var(--base-color-neutral--950)',
    color: 'var(--base-color-neutral--50)',
    duration: pillDuration,
  });

  ScrollTrigger.create({
    trigger: '[gsap="pill_trigger"]',
    start: 'bottom center',
    end: 'bottom bottom',
    scrub: false,
    markers: false,
    onEnter: () => {
      gsap.to(textBlocks[textBlocks.length - 1], {
        backgroundColor: 'var(--base-color-neutral--950)',
        color: 'var(--base-color-neutral--50)',
        duration: pillDuration,
      });
    },
    onLeaveBack: () => {
      gsap.to(textBlocks[textBlocks.length - 1], {
        backgroundColor: '',
        color: '',
        duration: pillDuration,
      });
    },
  });
};

(function () {
  function initializeAnimations() {
    if (window.animationsInitialized) {
      // If animations have already been initialized, do nothing
      return;
    }

    // Mark animations as initialized
    window.animationsInitialized = true;

    setupPillAnimations();
  }

  if (document.readyState === 'loading') {
    // DOM is still loading, so attach the event listener
    document.addEventListener('DOMContentLoaded', initializeAnimations);
  } else {
    // DOM is already loaded, so run immediately
    initializeAnimations();
  }
})();
